import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from "react";
import { Flex } from "theme-ui";
import { Label3, HeadingRegularVariants } from "../../index";
export const ArticleList = ({ title, countLabel, children }) => {
    return (_jsxs(Flex, { as: "section", sx: {
            flex: 1,
            width: "100%",
            flexDirection: "column"
        }, children: [_jsx(Flex, { sx: {
                    pb: 24,
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1px",
                    borderBottomColor: "grey.3",
                    mb: 24
                }, children: _jsxs(Flex, { sx: { flexDirection: "column" }, children: [title && (_jsx("h6", { sx: {
                                color: "black.1",
                                variant: `text.${HeadingRegularVariants.sixth}`
                            }, children: title })), children && (_jsxs(Label3, { sx: { color: "grey.1" }, children: [React.Children.count(children), " ", countLabel] }))] }) }), _jsx(Flex, { sx: {
                    flexDirection: "column",
                    flex: 1,
                    "> .article-list-item + .article-list-item": { mt: 24 }
                    // "& > :last-child": {
                    //   borderBottomWidth: "0px"
                    // }
                }, children: children })] }));
};
//# sourceMappingURL=ArticleList.js.map